import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import ReportingDocumentTree from '../documentViewers/json/AvaJsonTreeview';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const log = new Logger('TRANSACTION_INVOICE_BOOKING_INFORMATION', LOG_LEVELS.DEBUG);


class BookingInformation extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.bookingInformation) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <table className="mb20">
        <thead>
          <tr>
            <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_bookingInformation_accountNumber'/></th>
            <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_bookingInformation_vatCode'/></th>
            <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_bookingInformation_amount'/></th>
            <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_bookingInformation_currency'/></th>
          </tr>
        </thead>
        <tbody>
          {this.props.bookingInformation.map((item, index) => (
            <tr key={index}>
              <td>{item.accountNumber}</td>
              <td className={withFullStoryExclude()}>{item.vatCode}</td>
              <td className={withFullStoryExclude()}>{item.amount}</td>
              <td>{item.currency}</td>
            </tr>
          ))} 
        </tbody>
      </table>
    );
  }

}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(BookingInformation);
